import React from "react";

function WhatIsAnOrder() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is an Order Book DEX?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  An Order Book DEX (Decentralized Exchange) is a type of
                  decentralized exchange that operates on the principles of
                  traditional financial markets, utilizing an order book system
                  to facilitate the trading of cryptocurrencies and other
                  digital assets. Unlike Automated Market Maker (AMM) DEXs,
                  which use liquidity pools and automated pricing algorithms,
                  Order Book DEXs match buy and sell orders directly between
                  users.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhatIsAnOrder;
